import { render, staticRenderFns } from "./IconSet.vue?vue&type=template&id=4abf0f3c&scoped=true&"
import script from "./IconSet.vue?vue&type=script&lang=ts&"
export * from "./IconSet.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4abf0f3c",
  null
  
)

export default component.exports